import { ChainContext } from '@wormhole-foundation/sdk-connect';
/**
 * A ChainContext for the EVM platform
 */
export class EvmChain extends ChainContext {
}
//# sourceMappingURL=chain.js.map